<template>
  <thead class="custom-header">
  <tr>
    <th
        v-for="col in visibleColumns"
        :key="col.key"
        class="sortable position-relative th-custom"
        :style="{ width: col.minWidth || 'auto', maxWidth: col.maxWidth || '100%', textAlign: col.align }"
        @click="!hasFilter(col)"
    >
      <div class="th-header" @click="onSort(col)">
        <div class="th-left">
          <span class="th-title">{{ col.title }}</span>

          <span
              v-if="col.sortable"
              class="bh-sort-wrapper"
              :style="{ right: col.key === lastVisibleColumnKey && columnChooser ? '40px' : '8px' }"
              :class="{
                'bh-text-primary': sortKey === col.key,
                'bh-sort-desc': sortKey === col.key && sortOrder === 'desc'
              }"
          >
            <svg width="16" height="16" viewBox="0 0 14 14">
              <polygon points="3.11,6.25 10.89,6.25 7,1.75" fill="currentColor" />
            </svg>
          </span>
        </div>

        <div class="th-right" v-if="columnChooser && col.key === lastVisibleColumnKey">
          <button
              type="button"
              class="btn btn-sm column-chooser-btn"
              @click.stop="showColumnChooser()"
              v-tooltip="{
                text: $t('table-field.column-chooser-title'),
                theme: {
                  color: '#fff',
                  placement: 'left',
                  backgroundColor: '#000000'
                }
              }"
          >
            <i class="bi bi-list-check"></i>
          </button>
        </div>
      </div>

      <div class="th-filter" @click.stop>
        <slot
            :name="`th-${col.key}`"
            :column="col"
            :set-filter="(value) => updateFilter(col.key, value)"
        />
      </div>
    </th>
  </tr>
  </thead>
</template>

<script>
export default {
  name: "TableHeader",
  props: {
    columns: { type: Array, required: true },
    visibleColumnsState: { type: Object, required: true },
    sortKey: String,
    sortOrder: String,
    lastVisibleColumnKey: String,
    columnChooser: Boolean
  },
  emits: ["sort-change", "filter-change", "show-column-chooser"],

  computed: {
    visibleColumns() {
      return this.columns.filter(c => c && this.visibleColumnsState[c.key]);
    }
  },

  methods: {
    hasFilter(col) {
      return !!this.$slots[`th-${col.key}`];
    },

    onSort(col) {
      if (!col.sortable) return;
      this.$emit("sort-change", col);
    },

    updateFilter(key, value) {
      this.$emit("filter-change", { key, value });
    },

    showColumnChooser() {
      this.$emit("show-column-chooser");
    }
  }
};
</script>